import { DashboardSearchParams } from '@domain/types';
import { createSlice } from '@reduxjs/toolkit';

import { UpdateSearchParamsAction } from './inErrors.action';

interface InErrorsDashboardView {
  searchParams: DashboardSearchParams;
  total: number;
}

export interface InErrorsState {
  dashboardView: InErrorsDashboardView;
}

const INITIAL_IN_ERRORS_STATE: InErrorsState = {
  dashboardView: {
    searchParams: {
      page: 1,
      perPage: 20,
    },
    total: 0,
  },
};

// Create a redux store slice to keep dashboard filters state when we navigate across app pages
const slice = createSlice({
  name: 'inErrors',
  initialState: INITIAL_IN_ERRORS_STATE,
  reducers: {
    updateSearchParams: (state, action: UpdateSearchParamsAction) => {
      // Handle two cases from GetSearchParams interface:
      // 1. action.payload.search exists: merge new search params with current state
      // 2. action.payload.search is undefined: keep current search params unchanged
      const searchParams = action.payload.search
        ? { ...state.dashboardView.searchParams, ...action.payload.search }
        : { ...state.dashboardView.searchParams };

      return {
        ...state,
        dashboardView: {
          ...state.dashboardView,
          searchParams,
        },
      };
    },
  },
});

export const inErrorsReducer = slice.reducer;

export const InErrorsActions = slice.actions;
